module.exports = __webpack_public_path__ + "static/brett-ff20365d67fe162a5f72378352f5426b.jpg";